export const CATEGORY = 'Category';
export const CATEGORY_ADD = 'Category_add';
export const CATEGORY_DELETE = 'Category_deleted';
export const CATEGORY_EDIT = 'Category_edit';

export const CATEGORY_SETROWDATA = 'Category_set_rowdata';
export const MODEL_OPEN = 'Category_model_open';
export const MODEL_CLOSE = 'Category_model_close';

export const CATEGORY_LIST_SUCCESSFUL = 'Category_list_successfull';
export const CATEGORY_ADD_SUCCESSFUL = 'Category_add_successfull';
export const CATEGORY_EDIT_SUCCESSFUL = 'Category_edit_successfull';

export const API_ERROR = 'api_failed';
